import { supabase } from './supabase';

export function calcAnalytics(trades) {
  const closed = trades.filter(t =>
    t.resultat && t.resultat !== 'En cours' && t.resultat !== 'Fermé (historique)'
  );
  const historicalCount = trades.filter(t => t.resultat === 'Fermé (historique)').length;
  if (!closed.length) return null;
  const winners = closed.filter(t => (t.pnlUsd || 0) >= 0);
  const losers  = closed.filter(t => (t.pnlUsd || 0) < 0);
  const totalPnl      = closed.reduce((s, t) => s + (t.pnlUsd  || 0), 0);
  const totalInvested = closed.reduce((s, t) => s + (t.achatUsd || 0), 0);
  const bestTrade  = closed.reduce((b, t) => (t.roi||0) > (b.roi||0) ? t : b, closed[0]);
  const worstTrade = closed.reduce((w, t) => (t.roi||0) < (w.roi||0) ? t : w, closed[0]);
  const withDur    = closed.filter(t => t.entreeTs && t.sortieTs);
  const avgDuration = withDur.reduce((s, t) => s + (t.sortieTs - t.entreeTs), 0) / (withDur.length || 1);
  const simTrades  = closed.filter(t =>  t.isSim);
  const liveTrades = closed.filter(t => !t.isSim);
  const gainMoy  = winners.length > 0
    ? winners.reduce((s, t) => s + (t.pnlUsd || 0), 0) / winners.length : 0;
  const perteMoy = losers.length > 0
    ? Math.abs(losers.reduce((s, t) => s + (t.pnlUsd || 0), 0)) / losers.length : 0;
  return {
    total: closed.length, winners: winners.length, losers: losers.length,
    winRate: Math.round((winners.length / closed.length) * 100),
    totalPnl, totalInvested,
    totalPnlPct: totalInvested > 0 ? (totalPnl / totalInvested) * 100 : 0,
    bestTrade, worstTrade, avgDuration,
    simCount: simTrades.length, liveCount: liveTrades.length,
    simPnl:  simTrades.reduce((s, t) => s + (t.pnlUsd || 0), 0),
    livePnl: liveTrades.reduce((s, t) => s + (t.pnlUsd || 0), 0),
    historicalCount, gainMoy, perteMoy,
  };
}

export async function loadAndMergeTradesFromSupabase(overrideUserId = null, skipLocalStorage = false) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.user) return null;
  const targetId = overrideUserId || session.user.id;
  const { data } = await supabase
    .from('trades').select('*')
    .eq('user_id', targetId)
    .order('created_at', { ascending: false });
  if (!data?.length) return null;
  const mapped = data.map(t => ({
    id: t.id, symbol: t.symbol, mint: t.mint,
    entreeTs: t.entree_ts, sortieTs: t.sortie_ts,
    achatUsd: t.achat_usd, venteUsd: t.vente_usd,
    pnlUsd: t.pnl_usd, roi: t.roi, resultat: t.resultat,
    isSim: t.is_sim, walletSuivi: t.wallet_suivi,
    txHash: t.tx_hash, tokenAmount: t.token_amount,
    prixEntree: t.prix_entree, botWalletId: t.bot_wallet_id || null,
  }));
  if (skipLocalStorage) return mapped;
  const local  = JSON.parse(localStorage.getItem('bot-trades') || '[]');
  const localByTxHash = {};
  local.forEach(l => { if (l.txHash) localByTxHash[l.txHash] = l; });
  const patched = mapped.map(m =>
    m.txHash && !m.prixEntree && localByTxHash[m.txHash]?.prixEntree
      ? { ...m, prixEntree: localByTxHash[m.txHash].prixEntree }
      : m
  );
  const merged = [...patched, ...local.filter(l =>
    !l.txHash || !patched.find(m => m.txHash && m.txHash === l.txHash)
  )];
  localStorage.setItem('bot-trades', JSON.stringify(merged));
  return merged;
}
